import React from 'react';
import {Image, View} from 'react-native';

import OptaviaLogoHorizontal from '/asset/image/connect_logo_vertical.png';

import {styles} from './LoadingView.style';

export const LoadingView = ({}) => {
  return (
    <View style={styles.loadingView}>
      <Image
        style={styles.loadingImage}
        resizeMode="contain"
        source={OptaviaLogoHorizontal}
      />
    </View>
  );
};
